import { useLocation } from "react-router-dom";

// URL-based language: English lives at "/<page>", Chinese at "/tc/<page>".
export const DEFAULT_LOCALE = "en";
export const PREFIXED_LOCALES = ["tc"];

export function getLocaleFromPath(pathname) {
  const first = (pathname || "/").split("/")[1];
  return PREFIXED_LOCALES.includes(first) ? first : DEFAULT_LOCALE;
}

// "/tc/erp-system" -> "/erp-system", "/tc" -> "/"
export function stripLocale(pathname) {
  const locale = getLocaleFromPath(pathname);
  if (locale === DEFAULT_LOCALE) return pathname || "/";
  return pathname.slice(locale.length + 1) || "/";
}

// localizePath("/erp-system", "tc") -> "/tc/erp-system"
export function localizePath(path, locale) {
  if (!path || !path.startsWith("/")) return path;
  const bare = stripLocale(path);
  if (locale === DEFAULT_LOCALE || !PREFIXED_LOCALES.includes(locale)) return bare;
  return bare === "/" ? `/${locale}` : `/${locale}${bare}`;
}

// Returns lp(path): prefixes an internal path with the current page's language.
export function useLocalePath() {
  const { pathname } = useLocation();
  const locale = getLocaleFromPath(pathname);
  return (path) => localizePath(path, locale);
}
